import React from 'react'
import PropTypes from 'prop-types'
import balanceText from 'balance-text'
import Header from './Header/Header'
import sanitize from 'sanitize'
import { injectIntl } from 'react-intl'
import HappyLine from './HappyLine/HappyLine'

class SubPageHeader extends React.Component {
  balance() {
    balanceText('.c-sub-page-header__heading-text')
  }

  setClasses() {
    let classes = 'c-sub-page-header'
    if (this.props.magenta) classes += ' c-sub-page-header--magenta'
    if (this.props.blue) classes += ' c-sub-page-header--blue'
    if (this.props.dark)
      classes +=
        ' c-sub-page-header--dark bg-dark-mode-bg-light text-dark-mode-text'
    if (this.props.features) classes += ' c-sub-page-header--features'
    if (this.props.button) classes += ' c-sub-page-header--button'
    return classes
  }

  render = () => (
    <div className={this.setClasses()}>
      {!this.props.hideHeader && (
        <div>
          {!this.props.blog && this.props.magenta && (
            <Header onTopOfMagenta={true} logoOnly={this.props.logoOnly} />
          )}
          {!this.props.blog && this.props.blue && (
            <Header onTopOfBlue={true} logoOnly={this.props.logoOnly} />
          )}
          {!this.props.blog && !this.props.magenta && !this.props.blue && (
            <Header
              onTopOfGreen={true}
              logoOnly={this.props.logoOnly}
              sticky={this.props.stickyHeader}
            />
          )}
          {this.props.blog && (
            <Header
              loading={this.props.loading}
              onTopOfMagenta={true}
              blog={true}
              logoOnly={this.props.logoOnly}
            />
          )}
        </div>
      )}
      <div className="o-width-limiter o-width-limiter--full">
        {!this.props.loading && (
          <div>
            <h1
              className={
                this.props.smallHeading
                  ? 'c-sub-page-header__heading c-sub-page-header__heading--smaller'
                  : 'c-sub-page-header__heading'
              }
            >
              {this.props.preHeading && (
                <span className="c-sub-page-header__heading-pre">
                  {this.props.preHeading}
                </span>
              )}
              <span
                className="c-sub-page-header__heading-text"
                dangerouslySetInnerHTML={{
                  __html: sanitize(
                    typeof this.props.heading === 'object'
                      ? this.props.intl.formatMessage(this.props.heading)
                      : this.props.heading
                  ),
                }}
              />
            </h1>
            {this.props.summary && (
              <p className="c-sub-page-header__summary">{this.props.summary}</p>
            )}
            {this.props.children}
          </div>
        )}
        {this.props.loading && (
          <img
            className="c-loader  c-sub-page-header__loading"
            src={require('media/loader.gif')}
            alt="Loading…"
            width="55"
            height="55"
          />
        )}
      </div>
      <HappyLine
        color={
          this.props.dark
            ? 'black'
            : this.props.beigeCurve
            ? 'beige-lightest'
            : 'white'
        }
        className="c-sub-page-header__curve"
      />
    </div>
  )
}

SubPageHeader.defaultProps = {
  beigeCurve: true,
  dark: false,
  magenta: false,
  loading: false,
  animate: true,
  logoOnly: false,
  hideHeader: false,
  stickyHeader: true,
  button: false,
}

SubPageHeader.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  magenta: PropTypes.bool,
  blue: PropTypes.bool,
  dark: PropTypes.bool,
  features: PropTypes.bool,
  button: PropTypes.bool,
  hideHeader: PropTypes.bool,
  stickyHeader: PropTypes.bool,
  blog: PropTypes.bool,
  logoOnly: PropTypes.bool,
  loading: PropTypes.bool,
  smallHeading: PropTypes.bool,
  preHeading: PropTypes.string,
  summary: PropTypes.string,
  children: PropTypes.any,
  beigeCurve: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
}

export default injectIntl(SubPageHeader)
